import { useParams } from 'react-router-dom'
import { useContext, useEffect, useState } from 'react'
import { getRequest } from '../../../services/base'
import { NavContext } from '../../../context/global_context'
import { Row, Space, Typography } from 'antd'
import CsvDependencies from '../../../antd/vehicle/CsvDependencies'
import { useIntl } from 'react-intl'

const VehicleCSVDependencies = () => {
  const intl = useIntl()
  const [state, dispatch] = useContext(NavContext)
  const { vehicle } = useParams()
  const [vehicleDetails, setVehicleDetails] = useState({})
  const [error, setError] = useState('')

  useEffect(() => {
    getVehicleDetails()
  }, [])

  const getVehicleDetails = async () => {
    dispatch({
      type: 'loader',
      data: {
        caption: intl.formatMessage({ id: 'csvDependencies.fetchingData' }),
        showLoader: true,
      },
      notification: {},
    })
    let res = await getRequest(`/api/vehicles/vehicle_details/${vehicle}/`)
    // base.js leaves msg empty on a network failure, so the check below fell to
    // the else branch and rendered the error shape as the vehicle details.
    if (res?.status === false) {
      setError(intl.formatMessage({ id: 'generic.somethingWentWrong' }))
    } else {
      setVehicleDetails(res)
      setError('')
    }
    dispatch({
      type: 'loader',
      data: {},
      notification: {},
    })
  }

  return (
    <div className="page vehicle-dependencies">
      <Row className="title">
        <Space size={'middle'}>
          <Typography.Title level={2}>{intl.formatMessage({ id: 'csvDependencies.title' })}</Typography.Title>
        </Space>
      </Row>
      <Row className="body">
        {error ? (
          error
        ) : (
          <CsvDependencies
            vehicleDetails={vehicleDetails}
            setVehicleDetails={setVehicleDetails}
          />
        )}
      </Row>
    </div>
  )
}

export default VehicleCSVDependencies
